const allowNotificationsRead = (category, { permissions }) => ({
  dataset: permissions.datasets.read,
}[category]);

export default allowNotificationsRead;
